import { styled } from '@mui/material/styles';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { toggleButtonClasses } from '@mui/material/ToggleButton';

const calculateButtonGroupPadding = (theme, isSmall, withIcons, iconsOnly) => {
  if (iconsOnly) {
    return isSmall ? `${theme.spacing(0.25, 0.75)}` : `${theme.spacing(0.75)}`;
  }

  if (withIcons) {
    return `${theme.spacing(0.5, 1.5, 0.5, 1)}`;
  }

  return `${theme.spacing(0.5, 1.5)}`;
};

export const ToggleButtonGroupRoot = styled(ToggleButtonGroup, {
  name: 'AFToggleButtonGroup',
  shouldForwardProp: prop => prop !== 'withIcons' && prop !== 'iconsOnly'
})(({ theme, size, withIcons, iconsOnly }) => ({
  [`& .${toggleButtonClasses.root}`]: {
    padding: calculateButtonGroupPadding(
      theme,
      size === 'small',
      withIcons,
      iconsOnly
    )
  }
}));
